export const INVOICE_TYPE = {
  MONTHLY: 'MONTHLY',
  PO: 'PO',
  PROJECT: 'PROJECT',
};
